/* eslint-disable operator-linebreak */
import { getApiActionTypes } from 'store/utils/actions';

export const FETCH_RESERVATION_OUTSTANDING_DEPOSIT = getApiActionTypes(
  'FETCH_RESERVATION_OUTSTANDING_DEPOSIT'
);
